<template>
  <div class="home">
    <div class="webcam_wrapper" v-if="(examContinue == 'true' && remainingDuration != 0)">
      <Webcam v-if="showWebcam" @showWebcam="showHideWebcam" :showWebcam="showWebcam" :captureCount="captureCount" :captureMode="'exam'"></Webcam>
    </div>
    <!-- Top header Start:: desktop-view -->
    <div class="top-header exam-questions__accordian--desktop-view" data-toggle="modal" data-target="#completed-exam-modal">
      <div class="row">
        <div class="col-md-4">
          <div class="time-go">
            <button v-if="(examContinue == 'true' && remainingDuration != 0)" type="button" class="btn btn-primary">
              <div class="time-title"> Time Remaining：</div>
              <vue-countdown :time="remainingDuration" v-slot="{ days, hours, minutes, seconds }" @end="finishExam('timeout')" @progress="checkCapture">
               {{(days)? days + ' days :': '' }} {{(hours)? hours + ' hours :': '' }} {{(minutes)? minutes + ' minutes :': '' }} {{ seconds }} seconds
              </vue-countdown>
            </button>
          </div>
        </div>
        <div class="col-md-8">
          <div class="exam-code">
              <span v-if="examData.exam_master" class="badge badge-secondary">Exam Code: {{examData.exam_master.exam_code}}</span>
          </div>
          <div class="exam-name" v-if="examData.exam_master">
              {{(examData.exam_master.course)?examData.exam_master.course.name:''}} - {{(examData.exam_master.subject)?examData.exam_master.subject.name:''}}  - <span>{{examData.exam_master.exam_name}}</span>
          </div>
          <div class="top-profile">
            <img v-if="profileImageURL" :src="profileImageURL" />
            Hi <span>{{studentName}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="instruction-to-students">
              <span class="badge badge-danger" v-if="examData.exam_master"><b>Instruction to Students:</b>
                {{examData.exam_master.instrutions_to_students}}
              </span>
          </div>
        </div>
      </div>
    </div>
     <!-- Top header End:: desktop-view -->

    <!-- Top header Start:: Mobile-view -->
    <!-- <div class="top-header exam-questions__accordian--mobile-view" data-toggle="modal" data-target="#completed-exam-modal">
      <div class="row">
        <div class="col-md-4">
          <div class="time-go">
            <button v-if="(examContinue == 'true' && remainingDuration != 0)" type="button" class="btn btn-primary">
              <div class="time-title"> Time Remaining：</div>
              <vue-countdown :time="remainingDuration" v-slot="{ days, hours, minutes, seconds }" @end="finishExam('timeout')">
               {{(days)? days + ' days :': '' }} {{(hours)? hours + ' hours :': '' }} {{(minutes)? minutes + ' minutes :': '' }} {{ seconds }} seconds
              </vue-countdown>
            </button>
          </div>
        </div>
        <div class="col-md-8">
          <div class="exam-code">
              <span v-if="examData.exam_master" class="badge badge-secondary">Exam Code: {{examData.exam_master.exam_code}}</span>
          </div>
          <div class="exam-name" v-if="examData.exam_master">
              {{(examData.exam_master.course)?examData.exam_master.course.name:''}} - {{(examData.exam_master.subject)?examData.exam_master.subject.name:''}}  - <span>{{examData.exam_master.exam_name}}</span>
          </div>
          <div class="top-profile">
            <img v-if="profileImageURL" :src="profileImageURL" />
            Hi <span>{{studentName}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="instruction-to-students">
              <span class="badge badge-danger" v-if="examData.exam_master"><b>Instruction to Students:</b>
                {{examData.exam_master.instrutions_to_students}}
              </span>
          </div>
        </div>
      </div>
    </div> -->

      <div class="accordion exam-questions__accordian--mobile-view" id="accordionExample">
        <div class="card">
          <div class="card-head px-3 py-3" id="headingOne">
            <h2 class="mb-0" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                <span v-if="examData.exam_master" class="badge badge-dark p-3 text-left">Exam Code : {{examData.exam_master.exam_code}}</span>
            </h2>
          </div>

          <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
            <div class="card-body py-2 px-3">
              <div class="row">
                <div class="col-12">
                  <div class="header__accordian accordian_text my-2 text-center" v-if="examData.exam_master">
                    <p class="m-0 p-2"> {{(examData.exam_master.course)?examData.exam_master.course.name:''}} - {{(examData.exam_master.subject)?examData.exam_master.subject.name:''}}  - <span>{{examData.exam_master.exam_name}}</span></p>
                  </div>

                  <div class="header__accordian accordian_text-instruction my-2 text-center" v-if="examData.exam_master.instrutions_to_students">
                    <div class="">
                      <p class="p-2 m-0" v-if="examData.exam_master">Instruction to Students:   <span class="accordian_text-instruction--details">{{examData.exam_master.instrutions_to_students}}</span> </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Top header End:: Mobile-view -->



    <div class="row" v-if="(examContinue == 'true')">
      <div class="col-md-4">
        <div class="question-side">
            <div class="select-section exam-questions__accordian--desktop-view">
                <div class="btn-group">
                  <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{currentSection}}
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button v-for="(section, index) in examSectionData" :key="index" @click="selectedSectionIndex = index, currentSection = section.section_name" class="dropdown-item" type="button">{{section.section_name}}</button>
                  </div>
                </div>
            </div>
          <!-- Start Question Panel:: Mobile view -->
          <div class="row my-4 exam-questions__accordian--mobile-view mx-2">
            <div class="col-12">
              <button class="btn btn-success question-card__view-btn" @click="onDisplayQuestionCard()" v-if="!displayQuestionCard"> See Questions</button>
            </div>
          </div>

          <div class="custom-card card mr-2" id="fixed" v-if="displayQuestionCard">
            <div class="custom__accordian--header d-flex justify-content-between">
              <h5 class="card-title ">See All Questions</h5>
              <span role="button" aria-hidden="true" @click="onCloseQuestionCard()">&times;</span>
            </div>
            <div class="question-card__body card-body mt-5">
              <!--Questions category dropdown:: Start  -->
              <div class="select-section">
                <div class="btn-group">
                  <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{currentSection}}
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button v-for="(section, index) in examSectionData" :key="index" @click="selectedSectionIndex = index, currentSection = section.section_name" class="dropdown-item" type="button">{{section.section_name}}</button>
                  </div>
                </div>
              </div>
              <!--Questions category dropdown:: End  -->

               <!--Questions list:: Start  -->
              <ul v-for="(section, index) in examSectionData" :key="index" class="list-group" :class="(index == selectedSectionIndex)? 'showSection': 'hideSection'">
                <li v-for="(questionData, questionIndex) in section.questions" :key="questionIndex" @click="goToQuestion(questionData.student_question_id, questionIndex, selectedSectionIndex)" class="list-group-item list-group-item-action">
                  <div>
                    <strong>{{++questionIndex}}</strong>
                    <div class="dot" :class="(questionData.student_question_status == 'answered')? 'completed': ''"></div> <div class="answer-set">{{questionData.question_master.question_title}}</div>
                  </div>
                </li>
              </ul>
              <!--Questions list:: End -->
             <!-- End Question Panel:: Mobile view -->

            <!-- Questions: Start -->
              <!-- <div class="custom__accordian--element" v-for="(section, index) in examSectionData" :key="index" :class="(index == selectedSectionIndex)? 'showSection': 'hideSection'">
                    <div role="button" class="custom__accordian--element-body my-2 mx-2 py-2" v-for="(questionData, questionIndex) in section.questions" :key="questionIndex" @click="goToQuestion(questionData.student_question_id, questionIndex, selectedSectionIndex)">
                      <div class="row">
                        <div class="col-2 my-auto pr-0">
                          <span class="mx-2 mb-2">Que.</span>
                          <div v-if="(questionData.student_question_status == 'answered')" class="small ml-2">
                              <div class="avatar completed">  {{++questionIndex}}</div>
                          </div>

                          <div v-else class="small ml-2">
                              <div class="avatar red">{{++questionIndex}}</div>
                          </div>
                        </div>

                        <div class="col-10 my-auto pl-0">
                          <p class="p-0 m-0">{{questionData.question_master.question_title}}</p>
                        </div>
                      </div>
                    </div>
              </div> -->
            <!-- Questions: End -->
            </div>
          </div>
          <!-- end -->

        <!-- Start Question Panel:: Desktop view -->
          <div class="exam-questions__accordian--desktop-view">
            <ul v-for="(section, index) in examSectionData" :key="index" class="list-group" :class="(index == selectedSectionIndex)? 'showSection': 'hideSection'">
              <li v-for="(questionData, questionIndex) in section.questions" :key="questionIndex" @click="goToQuestion(questionData.student_question_id, questionIndex, selectedSectionIndex)" class="list-group-item list-group-item-action">
                <div>
                  <strong>{{++questionIndex}}</strong>
                  <div class="dot" :class="(questionData.student_question_status == 'answered')? 'completed': ''"></div> <div class="answer-set">{{questionData.question_master.question_title}}</div>
                  <!-- <span class="badge">
                      <img src="images/image.png" />
                  </span> -->
                </div>
              </li>
            </ul>
          </div>
        <!-- End:: Desktop view -->
        </div>
      </div>
      <div class="col-md-8 question-side">
        <div class="answer-side">
          <!--BEGIN: Question Block -->
          <div v-for="(questionData, questionIndex) in examData.exam_questions" :key="questionIndex" :id="'question_card_block_' + questionData.id" class="card" :class="(currentQuestion ==  questionData.id)? 'view_question': 'hide_question'">

            <!--BEGIN: Question Header -->
            <div class="card-header">
              <div class="q-area">
                <div class="q-number">{{currentQuestionNo}}</div>Question
              </div>
              <div class="q-tool">
                <div class="sp-tool">
                  <img src="images/mark.jpg" />
                  <span><strong>Marks:</strong> {{questionData.exam_question_master.marks}} Marks</span>
                </div>
                <div class="sp-tool last">
                  <img src="images/time.png" style="width:15px;" />
                  <span><strong>Time:</strong> {{questionData.exam_question_master.duration}} Mins</span>
                </div>
                <div class="sp-status">
                  <div class="sp-dot" :class="(questionData.answer_status == 'answered')? 'completed': ''"></div> {{(questionData.answer_status == 'answered')? 'Answered': (questionData.answer_status == 'visited')? 'Visited': 'Pending'}}
                </div>
              </div>
            </div>
            <!--END: Question Header -->

            <!--BEGIN: Question Answer Block -->
            <div class="card-body">
              <!-- <div class="erase"><img src="images/erase.png" /></div> -->
              <h5 class="card-title">{{questionData.exam_question_master.question_master.question_title}}</h5>
              <div class="question_text" v-if="questionData.exam_question_master.question_master.question_text != null && questionData.exam_question_master.question_master.question_text != ''">
                <textarea class="form-control" :value="questionData.exam_question_master.question_master.question_text" disabled></textarea>
              </div>
              <div v-if="(questionData.exam_question_master.question_master.question_media_upload)">
                  <div v-if="questionData.exam_question_master.question_master.question_media_upload.split('.').pop() === 'pdf' || questionData.exam_question_master.question_master.question_media_upload.split('.').pop() === 'PDF'" class="img-question">
                      <a title="Download file" :href="examDocumentURL+'/'+questionData.exam_question_master.question_master.question_media_upload" target="_BLANK"><img src="images/pdf.png" />Download</a><br>
                  </div>
                  <div v-else class="img-question">
                    <img :src="examDocumentURL+'/'+questionData.exam_question_master.question_master.question_media_upload" />
                  </div>
              </div>

              <div class="m-form__group form-group">

                <input type="hidden" :name="'question-type' + questionData.id" :id="'question-type' + questionData.id" :value="questionData.exam_question_master.question_master.question_type">

                <!--BEGIN: Text Answer Block -->
                <div v-if="questionData.exam_question_master.question_master.question_type == 0" class="m-text-list" >
                  <label v-for="(answerItem, answerIndex) in questionData.exam_question_master.question_master.question_answer_items" :key="answerIndex" class="m-text m-text--state-success w-100">
                    <textarea class="form-control" :name="'answer-item-' + questionData.id" :value="questionData.answer_text" placeholder="Type your answer here.!"></textarea>
                    <span></span>
                  </label>
                </div>
                <!--END: Text Answer Block -->

                <!--BEGIN: Radio Answer Block -->
                <div v-if="questionData.exam_question_master.question_master.question_type == 1" class="m-radio-list" :class="(questionData.exam_question_master.question_master.question_answer_items.length > 0)? (questionData.exam_question_master.question_master.question_answer_items[0].answer_media_upload)? 'with-images': '': ''">
                  <label v-for="(answerItem, answerIndex) in questionData.exam_question_master.question_master.question_answer_items" :key="answerIndex" class="m-radio m-radio--state-success">
                    <input type="radio" :name="'answer-item-' + questionData.id" :value="answerItem.id" :checked="(questionData.answer_options == answerItem.id)? true: false">
                    <img v-if="(answerItem.answer_media_upload)" :src="examDocumentURL+'/' + answerItem.answer_media_upload"  class="answer_image" style="width:200px; height:100% !important;margin-bottom:8px;margin-top:6px;" />
                    <div v-if="(answerItem.answer_media_upload)" class="answer_image_preview">
                      <div class="preview_block">
                        <img :src="examDocumentURL+'/' + answerItem.answer_media_upload"/>
                      </div>
                    </div>
                   {{answerItem.answer_text}}
                    <span></span>
                  </label>
                </div>
                <!--END: Radio Answer Block -->

                <!--BEGIN: Checkbox Answer Block -->
                <div v-if="questionData.exam_question_master.question_master.question_type == 2" class="m-checkbox-list" :class="(questionData.exam_question_master.question_master.question_answer_items.length > 0)? (questionData.exam_question_master.question_master.question_answer_items[0].answer_media_upload)? 'with-images': '': ''">
                  <label v-for="(answerItem, answerIndex) in questionData.exam_question_master.question_master.question_answer_items" :key="answerIndex" class="m-checkbox m-checkbox--state-success">
                    <input type="checkbox" :name="'answer-item-' + questionData.id" :value="answerItem.id" :checked="setAnswer(questionData.answer_options, answerItem.id)">
                    <img v-if="(answerItem.answer_media_upload)" :src="examDocumentURL+'/' + answerItem.answer_media_upload"  class="answer_image" style="width:200px; height:100% !important;margin-bottom:8px;margin-top:6px;"/>
                    <div v-if="(answerItem.answer_media_upload)" class="answer_image_preview">
                      <div class="preview_block">
                        <img :src="examDocumentURL+'/' + answerItem.answer_media_upload"/>
                      </div>
                    </div>
                    {{answerItem.answer_text}}
                    <span></span>
                  </label>
                </div>
                <!--BEGIN: Checkbox Answer Block -->

              </div>
              <div class="tip">
                  <span>Tip: </span> {{questionData.exam_question_master.question_master.answer_tips}}
                  <div class="img-question" v-if="(questionData.exam_question_master.question_master.answer_tips_media_upload)">
                    <a v-if="questionData.exam_question_master.question_master.answer_tips_media_upload.split('.').pop() === 'pdf' " title="download" :href="examDocumentURL+'/'+questionData.exam_question_master.question_master.question_media_upload" target="_BLANK"><img src="images/pdf.png" /></a><br>
                    <img v-if="questionData.exam_question_master.question_master.answer_tips_media_upload.split('.').pop() !== 'pdf' " :src="examDocumentURL+'/' + questionData.exam_question_master.question_master.answer_tips_media_upload" />

                  </div>
              </div>
            </div>
            <!--END: Question Answer Block -->

            <div class="card-footer">
              <div class="mobile-right">
                <button type="button" class="btn btn-secondary mobile-full-width" v-if="questionIndex != 0" @click="goToNextQuestion(questionData.id, 'back')">Back</button>
                <button type="button" class="btn btn-primary mobile-full-width" v-if="(questionIndex < (examData.exam_questions.length - 1))" @click="goToNextQuestion(questionData.id, 'next')">Save & Next</button>
                <button type="button" class="btn btn-success finish-exam mobile-full-width custom__bottom-btn" v-if="(questionIndex == (examData.exam_questions.length - 1))" @click="finishExam('clicked')">Finish Exam</button>
              </div>

            </div>
          </div>
          <!--END: Question Block -->

        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="result-area">
        <div class="top-status">
            <div class="row">
                <div class="col-md-2">
                    <div class="success-img">
                        <img  v-if="examResultSummery.grade" :src="'icons/'+examResultSummery.grade.image"/>
                        <img v-else src="images/success2.png" >
                    </div>
                </div>
               <!-- default show result -->
                <div class="col-md-4">
                  <div class="top-sucess" v-if="(examResultSummery.studentTotalMarks >= examData.exam_master.passing_percentage)">
                    <h2 v-if="examResultSummery.grade">{{examResultSummery.grade.text}}</h2>
                    <h2 v-else >Congratulations!</h2>
                    <span class="sub">
                      <div class="res pass" v-if="examResultSummery.grade">{{examResultSummery.grade.title}}</div>
                      <div class="res pass" v-else>Exam Passed</div>
                    </span>
                  </div>
                  <div class="top-sucess" v-else>
                    <h2 class="fail" v-if="examResultSummery.grade">{{examResultSummery.grade.text}}</h2>
                    <h2 class="fail" v-else >Nice Try!</h2>
                    <span class="sub">
                       <div class="res fail" v-if="examResultSummery.grade">{{examResultSummery.grade.title}}</div>
                      <div class="res fail" v-else>Exam Failed</div>
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="chart-right">
                      <apexchart type="donut" width="260" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </div>
            </div>
        </div>
        <div class="mid-result">
            <div class="row">
              <div class="col-md-6">
                  <div class="exam-date"><span>Start date:</span> {{examData.exam_master.start_date}}</div>
                  <div class="exam-date"><span>End date:</span> {{examData.exam_master.end_date}}</div>
              </div>
              <div class="col-md-6">
                <div class="sub-st">
                  <div class="set-res">
                    <span>{{examResultSummery.studentTotalMarks}}</span>
                  </div>
                  <span class="to-m">Your Total Marks</span>
                  </div>
                <div class="sub-st">
                  <div class="set-res">
                    <span class="out">{{examResultSummery.totalMarks}}</span>
                  </div>
                  <span class="to-m">Exam Out of Marks</span>
                  </div>
              </div>
            </div>
        </div>
        <div class="result-sheet">
          <div class="row">
            <div class="col-md-12">
              <div id="accordion">

                <div v-for="(question, index) in examData.exam_questions" :key="index" class="card">
                  <div class="card-header" :id="'heading_'+index">
                    <h5 class="mb-0">
                      <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse_'+index" aria-expanded="true" :aria-controls="'collapse_'+index">
                       {{index + 1}}. {{question.exam_question_master.question_master.question_title}}
                        <span class="excode">Question code: {{question.exam_question_master.question_master.question_code}}</span>
                      </button>
                    </h5>
                  </div>
                  <div :id="'collapse_'+index" class="collapse" :class="(index == 0)? 'show': ''" :aria-labelledby="'heading_'+index" data-parent="#accordion">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-10">
                          <div class="m-form__group form-group">
                            <div class="row">
                              <div v-if="(question.exam_question_master.question_master.question_media_upload)" class="col-md-3">
                                <div v-if="question.exam_question_master.question_master.question_media_upload.split('.').pop() === 'pdf' || question.exam_question_master.question_master.question_media_upload.split('.').pop() === 'PDF'" class="question-img attach-file">
                                       <a :href="examDocumentURL+'/'+question.exam_question_master.question_master.question_media_upload" target="_BLANK">Download File <img src="/media/files/file.png" /></a>
                                </div>
                                <div v-else class="question-img">
                                    <img :src="examDocumentURL+'/'+question.exam_question_master.question_master.question_media_upload" />
                                    <img class="question-img preview" :src="examDocumentURL+'/'+question.exam_question_master.question_master.question_media_upload"/>
                                </div>
                              </div>
                              <div :class="(question.exam_question_master.question_master.question_media_upload)? 'col-md-9': 'col-md-12'" >
                                <div class="row">
                                  <div class="col-md-12" v-if="question.exam_question_master.question_master.question_text">
                                   <div class="student_answer">
                                        <h3>Description</h3>
                                        <p>{{question.exam_question_master.question_master.question_text}}</p>
                                   </div>
                                  </div>
                                  <div v-for="(answers, answersIndex) in question.exam_question_master.question_master.question_answer_items" :key="answersIndex" :class="(question.exam_question_master.question_master.question_type != 0)? 'col-md-6': 'col-md-12'">

                                    <!-- Essay Answer -->
                                    <div v-if="(question.exam_question_master.question_master.question_type == 0)">
                                      <div class="student_answer">
                                        <h3>Your Answer</h3>
                                        <p>{{question.answer_text}}</p>
                                      </div>
                                      <div class="correct_answer">
                                        <h3>Correct Answer</h3>
                                        <p>{{answers.answer_text}}</p>
                                      </div>
                                      <div class="text_answer_image" v-if="(answers.answer_media_upload)">
                                          <div class="attach-file" v-if="answers.answer_media_upload.split('.').pop() === 'pdf' || answers.answer_media_upload.split('.').pop() === 'PDF'">
                                            <a :href="examDocumentURL+'/'+answers.answer_media_upload" target="_BLANK">Download File <img src="/media/files/file.png" /></a>
                                          </div>
                                          <div v-else>
                                            <img class="answer-img" :src="examDocumentURL+'/'+answers.answer_media_upload"/>
                                            <img class="answer-img preview" :src="examDocumentURL+'/'+answers.answer_media_upload"/>
                                          </div>
                                      </div>
                                    </div>

                                    <!-- Radio Answer -->
                                    <div v-if="(question.exam_question_master.question_master.question_type == 1)" class="m-radio-list">
                                      <label class="m-radio m-radio--state-success" :class="[(answers.answer_media_upload)? 'with-images': 'without-images',  (answers.is_correct_answer)? 'correct-answer': '']" >
                                        <input disabled type="radio" :checked="(answers.id == question.answer_options)? true: false">
                                        <div class="mark-status" :class="(answers.id == question.answer_options)? (answers.is_correct_answer)? 'correct': 'wrong': 'd-none'">
                                            <img v-if="(answers.is_correct_answer)" class="correct-pic" src="images/correct.png" />
                                            <img v-else src="images/close2.png" />
                                        </div>
                                        {{answers.answer_text}}
                                        <div v-if="(answers.answer_media_upload)">
                                            <div class="attach-file" v-if="answers.answer_media_upload.split('.').pop() === 'pdf' || answers.answer_media_upload.split('.').pop() === 'PDF'">
                                              <a :href="examDocumentURL+'/'+answers.answer_media_upload" target="_BLANK">Download File <img src="/media/files/file.png" /></a>
                                            </div>
                                            <div v-else>
                                              <img class="answer-img" :src="examDocumentURL+'/'+answers.answer_media_upload"
                                                style="width:200px; height:100% !important;margin-bottom:8px;margin-top:6px;"/>
                                            </div>
                                        </div>
                                        <span></span>
                                        <div class="que-status" :class="(answers.id == question.answer_options)? (answers.is_correct_answer)? 'correct1': 'wrong1': 'd-none1'">{{(answers.is_correct_answer)? 'Correct Answer : ': (answers.id == question.answer_options)? 'Wrong Answer : ': ''}}<div class="no-answer">{{(answers.id == question.answer_options)? 'Answered': 'Not Answered'}}</div></div>
                                      </label>
                                    </div>

                                    <!-- Checkbox Answer -->
                                    <div v-if="(question.exam_question_master.question_master.question_type == 2)" class="m-checkbox-list">
                                      <label class="m-checkbox m-checkbox--state-success" :class="[(answers.answer_media_upload)? 'with-images': 'without-images',  (answers.is_correct_answer)? 'correct-answer': '']" >
                                        <input disabled type="checkbox" :checked="setAnswer(question.answer_options, answers.id)">
                                        <div class="mark-status" :class="setAnswer(question.answer_options, answers.id)? (answers.is_correct_answer)? 'correct': 'wrong': 'd-none'">
                                            <img v-if="(answers.is_correct_answer)" class="correct-pic" src="images/correct.png" />
                                            <img v-else src="images/close2.png" />
                                        </div>
                                        <img v-if="(answers.answer_media_upload)" class="answer-img" :src="examDocumentURL+'/'+answers.answer_media_upload"
                                            style="width:200px; height:100% !important;margin-bottom:8px;margin-top:6px;"/>
                                        {{answers.answer_text}}
                                        <span></span>
                                        <div class="que-status" :class="(answers.id == question.answer_options)? (answers.is_correct_answer)? 'correct1': 'wrong1': 'd-none1'">{{(answers.is_correct_answer)? 'Correct Answer : ': setAnswer(question.answer_options, answers.id)? 'Wrong Answer : ': ''}}<div class="no-answer">{{setAnswer(question.answer_options, answers.id)? 'Answered': 'Not Answered'}}</div></div>
                                      </label>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 right-info">
                          <ul class="list-group">
                            <li class="list-group-item">
                              <img src="https://revampadmin.webcolms.com/assets/demo/default/custom/img/marks.png" />
                              {{question.exam_question_master.marks}} Marks
                              </li>
                            <li class="list-group-item">
                              <img class="time" src="https://revampadmin.webcolms.com/assets/demo/default/custom/img/clock.png" />
                              {{question.exam_question_master.duration}} Mins</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Completed Exam Modal -->
    <div class="modal fade exam-page-modal" id="complete-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Complete Exam</h5>
            <img v-if="finishExamType == 'clicked'" class="close" src="/media/icons/close.png" data-dismiss="modal" @click="resetQuestionData()" aria-label="Close" width="53px" :style="[finishExamType=='clicked'] ? {'display':'block'} : {'display':'none'}" />
          </div>
          <div class="modal-body">
            <p id="finishMsg"></p>
          </div>
          <div class="modal-footer">
            <button v-if="finishExamType == 'clicked'" type="button" class="btn btn-secondary" @click="resetQuestionData()" data-dismiss="modal">Close</button>
            <button v-if="finishExamType == 'clicked'" class="btn btn-primary" @click="showReviewPage()">Review my Exam</button>
            <button v-else class="btn btn-primary" @click="showReviewPage()">Okay, Complete my Exam</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Webcam from '@/components/template/Webcam'
var Config = require('../router/Config')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')
// var userPermissions = Cookies.get('userPermissions')

var startExam = {
  name: 'startexam',
  components: { Webcam },
  props: [],
  data () {
    return {
      studentName: (Cookies.get('firstName')) ? Cookies.get('firstName') : false,
      profileImageURL: (Cookies.get('profileImage')) ? Config.API_URL + '/user/' + Cookies.get('profileImage') : './media/users/blank-profile-picture.png',
      examContinue: (Cookies.get('examContinue')) ? Cookies.get('examContinue') : false,
      examDocumentURL: Config.EXAM_DOCUMENTS + Cookies.get('clientId'),
      examData: [],
      examSectionData: [],
      selectedSectionIndex: (Cookies.get('selectedSectionIndex')) ? Cookies.get('selectedSectionIndex') : 0,
      clientId: Cookies.get('clientId'),
      currentSection: (Cookies.get('currentSection')) ? Cookies.get('currentSection') : 'Select Section',
      currentQuestion: (Cookies.get('currentQuestion')) ? Cookies.get('currentQuestion') : 0,
      currentQuestionNo: (Cookies.get('currentQuestionNo')) ? Cookies.get('currentQuestionNo') : 1,
      examResultSummery: [],
      remainingDuration: 0,
      startTimestamp: Date.now(),
      endTimestamp: 0,
      finishExamType: 'clicked',
      series: [0, 0, 0],
      skippedQuestionCOunt: 0,
      skippedQuestions: '',
      showWebcam: false,
      captureCount: 0,
      isExamEnded: false,
      examFaceCapture: false,
      isSetCues: false,
      imageCount: 4,
      examDuration: 0,
      pauseTimestamp: 0,
      captureTimestamps: [],
      chartOptions: {
        labels: ['Correct', 'Wrong', 'Not attend'],
        colors: ['#3dc21a', '#ff0000', '#f2b600'],
        chart: {
          width: 240,
          type: 'donut'
        },
        dataLabels: {
          enabled: false
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              show: false
            }
          }
        }],
        legend: {
          position: 'left',
          offsetY: 0,
          height: 230,
          horizontalAlign: 'center'
        }
      },
      displayQuestionCard:false,
      constraints: {
        audio: false,
        video: { width: 1280, height: 720 }
      },
    }
  },
  beforeCreate: function () {
    var startExam = Cookies.get('startExam')
    if (startExam == 'true') {
      Cookies.set('currentQuestion', '')
      Cookies.set('currentQuestionNo', 1)
      Cookies.set('currentSection', 'Select Section')
      Cookies.set('examContinue', true)
      Cookies.set('selectedSectionIndex', 0)
      Cookies.set('startExam', false)
    }
  },
  beforeMount: function () {
    if (userPermissions.exam_video_face_capture) {
      this.examFaceCapture = true
    }
  },
  mounted () {
    this.getStartExamData()
    $('body').addClass('exam-body')
    // this.getMinutesSeconds()
  },
  methods: {
    getStartExamData: function () {
      this.axios.post(Config.API_URL + '/api/fe/exam/load-exam-questionnaire' + '?token=' + Cookies.get('accessToken'), {
        studentId: Cookies.get('studentId'),
        studentExamIdToStart: Cookies.get('studentExamIdToStart')
      }).then(response => {
        this.examData = response.data.examData
        this.remainingDuration = parseInt(this.examData.remaining_duration)
        this.examSectionData = response.data.sectionData
        this.currentQuestion = (Cookies.get('currentQuestion'))? Cookies.get('currentQuestion'): this.examData.exam_questions[0].id
        this.examResultSummery = response.data.examResultSummery
        this.series = [this.examResultSummery.studentCorrect, this.examResultSummery.studentWrong, this.examResultSummery.studentNotAttend]

        Cookies.set('currentQuestion', this.currentQuestion)
        Cookies.set('currentSection', this.examSectionData[0].section_name)
        console.log(response.data)
        this.setCaptureTimestamp()
      }).catch(function (error) {
        console.log(error)
      })
    },
    goToQuestion: function (questionId, questionIndex, sectionIndex) {
      this.displayQuestionCard = false;
      var currentQuestionType = $('#question-type' + this.currentQuestion).val()
      var answer = []
      if (currentQuestionType == 0) {
        answer.push($('textarea[name="answer-item-' + this.currentQuestion + '"]').val())
      }
      if (currentQuestionType == 1) {
        answer.push($('input[type="radio"][name="answer-item-' + this.currentQuestion + '"]:checked').val())
      }
      if (currentQuestionType == 2) {
        $.each($("input[name='answer-item-" + this.currentQuestion + "']:checked"), function () {
          answer.push($(this).val())
        })
      }

      this.endTimestamp = Date.now()
      var remainDuration = this.remainingDuration
      var spentTime = (this.endTimestamp - this.startTimestamp)/1000
      remainDuration = ((remainDuration /1000) - spentTime) * 1000

      this.axios.post(Config.API_URL + '/api/fe/exam/save-update-question' + '?token=' + Cookies.get('accessToken'), {
        examId: Cookies.get('studentExamIdToStart'),
        remainingDuration: remainDuration,
        examQuestionId: this.currentQuestion,
        examQuestionType: currentQuestionType,
        examQuestionAnswer: answer,
        examStatus: ''
      }).then(response => {
        this.selectedSectionIndex = sectionIndex
        this.currentQuestion = questionId
        this.currentQuestionNo = questionIndex
        this.currentSection = this.examSectionData[this.selectedSectionIndex].section_name
        this.examData = response.data.responseData
        this.examSectionData = response.data.sectionData

        Cookies.set('currentSection', this.currentSection)
        Cookies.set('currentQuestion', this.currentQuestion)
        Cookies.set('currentQuestionNo', this.currentQuestionNo)
        Cookies.set('selectedSectionIndex', this.selectedSectionIndex)
      }).catch(function (error) {
        console.log(error)
      })
    },
    setAnswer: function (answerList, answerId) {
      if (answerList) {
        if (answerList.length == 1) {
          if (answerList == answerId) {
            return true
          } else {
            return false
          }
        } else if (answerList.length > 1) {
          var answersArray = answerList.split(",")
          for (let index = 0; index < answersArray.length; index++) {
            if (answersArray[index] == answerId) {
              return true
            }
          }
        }
      } else {
        return false
      }
    },
    goToNextQuestion: function (currentQuestionId, stepType) {
      var sectionCount = this.examSectionData.length
      var currentSectionPosition = parseInt(this.selectedSectionIndex) + 1
      var sectionTotalQuestions = this.examSectionData[this.selectedSectionIndex].total_questions
      var currentQuestionPosition = this.currentQuestionNo

      var goToSectionIndex = this.selectedSectionIndex;
      var goToQuestionNo = this.currentQuestionNo;

      if (stepType == 'next') {
        if (currentQuestionPosition < sectionTotalQuestions) {
          goToQuestionNo++
        } else {
          if (currentSectionPosition < sectionCount) {
            goToQuestionNo = 1
            goToSectionIndex++
          }
        }
      } else {
        if (currentQuestionPosition > 1) {
          goToQuestionNo--
        } else {
          if (currentSectionPosition > 1) {
            goToSectionIndex--
            goToQuestionNo = this.examSectionData[goToSectionIndex].total_questions
          }
        }
      }

      console.log('goToSectionIndex new :' + goToSectionIndex +' goToQuestionNo new :' + goToQuestionNo)
      var questionIndex = goToQuestionNo - 1
      var questionId = this.examSectionData[goToSectionIndex].questions[questionIndex].student_question_id
      console.log(questionId)
      this.goToQuestion(questionId, goToQuestionNo, goToSectionIndex)
    },
    finishExam: function (finishType) {
      // this.setEndedWebcamCapture();
      var currentQuestionType = $('#question-type'+this.currentQuestion).val()
      var answer = []
      if (currentQuestionType == 0) {
        answer.push($('textarea[name="answer-item-'+this.currentQuestion+'"]').val())
      }
      if (currentQuestionType == 1) {
        answer.push($('input[type="radio"][name="answer-item-' + this.currentQuestion + '"]:checked').val())
      }
      if (currentQuestionType == 2) {
        $.each($("input[name='answer-item-" + this.currentQuestion + "']:checked"), function () {
          answer.push($(this).val())
        })
      }
      this.axios.post(Config.API_URL + '/api/fe/exam/save-update-question' + '?token=' + Cookies.get('accessToken'), {
        examId: Cookies.get('studentExamIdToStart'),
        remainingDuration: this.remainingDuration,
        examQuestionId: this.currentQuestion,
        examQuestionType: currentQuestionType,
        examQuestionAnswer: answer,
        examStatus: 'completed'
      }).then(response => {
        this.examData = response.data.responseData

        if (finishType == 'clicked') {
          this.finishExamType = 'clicked'
          this.getStartExamData()
          this.skippedQuestionCOunt = this.examData.exam_questions.filter(function (item) {
            return item.answer_status === 'visited';
          }).length;
          if(this.skippedQuestionCOunt > 0) {
            this.examData.exam_questions.forEach((element, index) => {
              if(element.answer_status === 'visited') {
                const questionNumber = index+1
                this.skippedQuestions += questionNumber + ','
              }
            });
            $('#finishMsg').empty().html('You have some skipped question/s (Question: ' + this.skippedQuestions.substring(0, this.skippedQuestions.length - 1) + '). Are you sure to continue?')
          } else {
            $('#finishMsg').empty().html('Congratulations! The Exam completed successfully.!')
          }
        } else {
          this.finishExamType = 'timeout'
          $('#finishMsg').empty().html(this.studentName + ', Your exam time has been ended')
        }
        $('#complete-exam-modal').modal('show')
      }).catch(function (error) {
        console.log(error)
      })
    },
    showReviewPage: function () {
      this.examContinue = false
      Cookies.set('examContinue', this.examContinue)
      location.reload()
    },
    resetQuestionData: function () {
      this.skippedQuestions = ''
      this.skippedQuestionCOunt = 0
    },
    onDisplayQuestionCard () {
      this.displayQuestionCard = true;
    },
    onCloseQuestionCard () {
      this.displayQuestionCard = false;
    },
    setCaptureTimestamp () {
      this.isExamEnded = false
      if (this.examFaceCapture) {
        if (!this.isSetCues) {
          console.log('dur',this.remainingDuration)
          var timeSlot = parseInt(this.remainingDuration / this.imageCount)
          console.log('timeslot',this.remainingDuration)
          this.isSetCues = true
          for (let index = 0; index < this.imageCount; index++) {
            var randomTimeSlot = Math.floor(Math.random() * timeSlot + 1)
            var pauseTime = this.pauseTimestamp + randomTimeSlot
            this.pauseTimestamp += timeSlot

            pauseTime = Math.trunc(pauseTime / 1000);
            console.log(pauseTime * 1000)

            this.captureTimestamps.push(pauseTime * 1000)
          }
        }
      }
    },
    setWebcamCapture (event) {
      var self = this
      navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
        self.showWebcam = true
        self.captureCount++
        Cookies.set('captureCount', self.captureCount)
        console.log('webcam started for image no: ' + self.captureCount + ' : time: ' + event.time)
      }).catch(function (err) {
        console.log(err)
      })
    },
    setEndedWebcamCapture (event) {
      if (this.examFaceCapture) {
        var self = this
        navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
          self.showWebcam = true
          self.captureCount++
          Cookies.set('captureCount', self.captureCount)
          console.log('captureCount: ' + self.captureCount + ' == video ended')
        }).catch(function (err) {
          console.log(err)
        })
      }
    },
    checkCapture (data) {
      console.log('ar',this.captureTimestamps)
      if (this.captureTimestamps.includes(data.totalMilliseconds)) {
        this.setWebcamCapture(data.totalMilliseconds)
      }
    },
    showHideWebcam (status) {
      this.showWebcam = status
    },
  }
}
export default startExam
</script>

<style scoped lang="scss">
    @import "../assets/scss/component/exam/exam";

    @media (max-width:767px) {
      .mobile-right {
        text-align: right !important;
        margin-left: 0px !important;
      }
      .mobile-full-width {
        width: 100% !important;
        margin: 6px 0px 10px  0!important;
      }

      .custom__bottom-btn {
          margin-bottom: 15px;
      }

      .top-status {
        margin-top: 10px !important;
      }

      .result-area {
        margin-top: 10px !important;
      }

      .chart-right {
        margin: 0px !important;
      }

      .exam-questions__accordian--mobile-view {
        display: block;
      }

      .exam-questions__accordian--desktop-view {
        display: none;
      }

      .question-side {
        background: transparent !important;
      }
    }

    @media (max-width:320px) {
      .to-m {
        width: 79% !important;
      }
    }

     @media (min-width:321px) and (max-width:767px){
      .to-m {
        width: 82.9% !important;
      }
    }

       @media (min-width:361px) and (max-width:375px){
        .to-m {
          width: 82% !important;
        }
      }

         @media (min-width:400px) and (max-width:767px){
        .to-m {
          width: 84.5% !important;
        }
      }

    @media (min-width:768px) {
      .exam-questions__accordian--mobile-view {
        display: none;
      }

      .exam-questions__accordian--desktop-view {
        display: block;
      }
    }

// mobile view card styles

   @media (min-width:320px) and (max-width:376px){
      #fixed {
          min-height: 580px !important;
      }
   }

  //   @media (min-width:371px) and (max-width:376px){
  //     #fixed {
  //         min-height: 680px !important;
  //     }
  //  }

    @media (min-width:377px) and (max-width:420px){
      #fixed {
          min-height: 600px !important;
      }
    }

    .custom__accordian--header {
      width: 95%;
      position: fixed;
      background: #333333;
      color: #fff;
      padding: 10px 15px;
      border-radius: 0 0.5rem 0 0;
      z-index: inherit;
    }

    .custom__accordian--header-text {
      color: #fff;
      font-weight: 550;
    }

    .custom__accordian--element-body {
      font-weight: 550;
      border-radius: 5px;
      border: 1px #222 solid;
      padding: 20px 0px;
    }

    .custom__accordian--question-item:hover {
      opacity: 0.5;
    }

    #fixed {
      position: fixed;
      top:14%;
      bottom: 50%;
      left: 0;
      margin: 0;
      width: 95%;
      z-index: 9999;
      min-height: 620px;
      overflow-y: scroll;
      box-shadow: 0px 1px 10px #999;
    }

    .question-card__body {
      background: #F7F7F7;
      padding: 0.5rem !important;
      border-radius: 0 0 0.5rem 0;
    }

    .question-card__view-btn {
      width: 100%;
      margin-left: 0px;
      background: #ffae00;
      color: #fff;
      border: #ffae00;
      font-family: 'Roboto', sans-serif;
      font-weight: 500;
    }

    // Question circle styles
    .avatar {
      border-radius: 100%;
      overflow: hidden;
      width: 25px;
      height: 25px;
      background: transparent;
      padding: 5px 10px;
      color: #fff;
    }

    .small {
      vertical-align: baseline;
    }

    .completed {
       background-color: #23d613;
    }

    .red {
       background-color: red;
    }

    .custom-card {
      background: #fff;
      width: 400px;
    }

    //

    #headingOne {
      background: #ebedf2;
     box-shadow: 0px 1px 10px #999;
    }

    .accordion .card h2 {
      background: url(https://cdn0.iconfinder.com/data/icons/entypo/91/arrow56-512.png) no-repeat calc(100% - 10px) center;
      background-size: 20px;
      cursor: pointer;
      font-size: 18px;
    }

    .accordion .card h2.collapsed {
      background-image: url(https://cdn0.iconfinder.com/data/icons/arrows-android-l-lollipop-icon-pack/24/expand2-256.png);
    }

    #headingOne .accordion .card h2.collapsed {
      box-shadow: none;
    }

    .accordion .card-body {
      padding-left: 0;
      padding-right: 0;
      box-shadow: 0px 15px 10px -15px #999;
    }

    .accordion-button:not(.collapsed), .accordion-button:not(.collapsed):focus  {
      box-shadow: none
    }

    .header__accordian {
      font-size: 16px;
      font-weight: 600;
    }

    .accordian_text-instruction {
      font-size: 14px;
      font-weight: 600;
    }

    .accordian_text-instruction--details {
      font-size: 14px;
      font-weight: 500;
    }
</style>
